<template>
  <v-overlay
    :model-value="Boolean(id)"
    content-class="document-preview-container"
    @click:outside="close"
    @keydown.esc="close"
  >
    <section aria-label="Preview">
      <v-sheet class="preview">
        <div
          v-if="loading"
          class="pa-6 d-flex flex-column ga-4 h-100"
        >
          <div class="preview-header d-flex align-center">
            <div class="d-flex align-center ga-2 ml-auto">
              <slot name="actions" />
              <v-btn
                size="32"
                variant="plain"
                color="textDarkest"
                aria-label="Close preview"
                @click="close"
              >
                <v-icon icon="$close" />
              </v-btn>
            </div>
          </div>

          <slot name="loading">
            <div class="d-flex justify-center flex-grow-1">
              <v-progress-circular
                indeterminate
                color="brandPrimary"
                size="48"
                width="3"
              />
            </div>
          </slot>
        </div>

        <div
          v-if="!loading"
          class="pa-6 d-flex flex-column ga-4"
        >
          <div class="preview-header d-flex align-center">
            <div class="d-flex align-center ga-2 ml-auto">
              <slot name="actions" />
              <v-btn
                size="32"
                variant="plain"
                color="textDarkest"
                aria-label="Close preview"
                @click="close"
              >
                <v-icon icon="$close" />
              </v-btn>
            </div>
          </div>

          <slot />
        </div>
      </v-sheet>
    </section>
  </v-overlay>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router';
import { computed } from 'vue';

const route = useRoute();
const router = useRouter();

defineProps({ loading: { type: Boolean, default: false } });

const id = computed(() => route.query?.preview);

const close = () => router.replace({
  query: {
    ...route.query,
    preview: undefined,
    type: undefined,
    previewTitle: undefined,
  },
});
</script>

<style scoped lang="less">
:global(.document-preview-container) {
  // move content to the right side of screen
  right: 0;
}

.preview {
  width: 533px;
  height: 100vh;
  overflow-y: auto;
}
</style>
